import React, { Component } from 'react'
import * as styled from '../../../styles/style'

class ToolTip extends Component {
  constructor() {
    super()
    this.state = {
      open: false
    }
  }
  toggleOpen = (e) => {
    this.setState({
      open: !this.state.open,
    }, () => {
      if (this.state.open) {
        setTimeout(() => {
          window.addEventListener('click', this.hardClose)
        }, 250)
      }
      else {
        setTimeout(() => {
          window.removeEventListener('click', this.hardClose)
        }, 250)
      }
    })
  }
  hardClose = (e) => {
    this.setState({
      open: false,
    })
    window.removeEventListener('click', this.hardClose)
  }
  render() {
    let { linkText, left, style } = this.props
    left = typeof left !== 'undefined' ? left : window.innerWidth < 600
    return (
      <div style={style}>
        <styled.ToolTipLink onClick={this.toggleOpen}>
          {linkText}
          {this.state.open && (
            <styled.ToolTip className={left ? 'left' : ''}>
              {this.props.children}
              <span className="button">Close</span>
            </styled.ToolTip>
          )}
        </styled.ToolTipLink>
      </div>
    )
  }
}

export default ToolTip
